/* global Swiper */
const imageSliderOne = document.querySelectorAll('[data-slider="image-slider__init-1"]');
const imageSliderTwo = document.querySelectorAll('[data-slider="image-slider__init-2"]');
const contentSliderElement = document.querySelectorAll('[data-slider="image-content-slider"]');

function pad(d) {
  return d < 10 ? `0${d.toString()}` : d.toString();
}

const imageSliderOptions = {
  slidesPerView: '1',
  simulateTouch: false,
  touchRatio: 0,
  loop: true,
  speed: 500,
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
};

// *******************************************************************************
// 1.0 - Tumbnail slider
// *******************************************************************************

Array.prototype.forEach.call(imageSliderTwo, (el) => {
  const imageSliderParent = el.closest('.sc-image-slider');
  const arrowRight = imageSliderParent.querySelector('.arrow--right');
  const arrowLeft = imageSliderParent.querySelector('.arrow--left');

  imageSliderOptions.navigation.nextEl = arrowRight;
  imageSliderOptions.navigation.prevEl = arrowLeft;

  // eslint-disable-next-line no-unused-vars
  const sliderTwo = new Swiper(el, imageSliderOptions);

  sliderTwo.slideTo(2, 0);
});

// *******************************************************************************
// 2.0 - Main slider
// *******************************************************************************

Array.prototype.forEach.call(imageSliderOne, (el) => {
  const imageSliderParent = el.closest('.sc-image-slider');
  const totalSlidesElement = imageSliderParent.querySelector('.total-slide');
  const currentSlidesElement = imageSliderParent.querySelector('.current-slide');
  const arrowRight = imageSliderParent.querySelector('.arrow--right');
  const arrowLeft = imageSliderParent.querySelector('.arrow--left');

  imageSliderOptions.navigation.nextEl = arrowRight;
  imageSliderOptions.navigation.prevEl = arrowLeft;

  // eslint-disable-next-line no-unused-vars
  const sliderOne = new Swiper(el, imageSliderOptions);

  sliderOne.on('transitionEnd', () => {
    const currentSlideContentElement = imageSliderParent.querySelector('.swiper-slide-active .image-slider__img');
    const currentSlideNum = currentSlideContentElement.getAttribute('data-num');
    currentSlidesElement.innerHTML = pad(currentSlideNum);
  });

  if (totalSlidesElement) {
    totalSlidesElement.innerHTML = pad(el.getAttribute('data-total-slide'));
  }
});

// *******************************************************************************
// 3.0 - Content slider
// *******************************************************************************

Array.prototype.forEach.call(contentSliderElement, (el) => {
  const imageSliderParent = el.closest('.sc-image-slider');
  const arrowRight = imageSliderParent.querySelector('.arrow--right');
  const arrowLeft = imageSliderParent.querySelector('.arrow--left');

  const contentSliderOptions = {
    slidesPerView: 1,
    loop: true,
    speed: 500,
    simulateTouch: false,
    touchRatio: 0,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: arrowRight,
      prevEl: arrowLeft,
    },
  };
  // eslint-disable-next-line no-unused-vars
  const contentSlider = new Swiper(el, contentSliderOptions);
});
